<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar
      title="写文章"
      right-text="发表"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      @click-right="onClickRight"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div>
      <van-field v-model="title" placeholder="添加标题" />
      <van-field
        v-model="message"
        rows="8"
        autosize
        type="textarea"
        placeholder="写点什么"
        show-word-limit
        :border="false"
      />
    </div>
    <div class="btn-area">
      <van-button @click="onClickRight()" class="mybtn" block
        >发表</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
export default {
  data() {
    return {
      title: "",
      message: "",
      issubmit: false,
      id: 0,
      mid: "",
    };
  },
  components: {},
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    onClickRight() {
      var that = this;
      if (that.title == "" || that.title.length == 0) {
        Toast("标题不能为空！");
        return;
      }
      if (that.message == "" || that.message.length == 0) {
        Toast("内容不能为空！");
        return;
      }
      if (!that.issubmit) {
        that.issubmit = true;
        that.$store
          .dispatch({
            type: "MemorialArticleMemorialArticleAddVue",
            MemorialHallID: that.uid,
            Title: that.title,
            Content: that.message,
            MemorialArticleType: 2,
          })
          .then(
            (res) => {
              setTimeout(function() {
                that.issubmit = false;
                that.$router.go(-1);
              }, 2000);
              if (res.IsSuccess) {
                Toast("发表文章成功，请等待审核！");
              }
            },
            (err) => {
              that.issubmit = false;
            }
          );
      }
    },
  },
  created() {
    var that = this;
    this.uid = this.$store.state.muid;
  },
};
</script>

<style scoped></style>
